import { BladeDamagesRepository } from "@/api/Repositories";
import { BladeDamageIsInBladeZonesRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then(response => {
            const data = response.data.data.blade_damage_is_in_blade_zone
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        BladeDamageIsInBladeZonesRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {      
      return new Promise((resolve, reject) => {
        BladeDamageIsInBladeZonesRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        BladeDamageIsInBladeZonesRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
